export default __webpack_public_path__ + "static/media/iconfac.359615b9.svg";